import axios from 'axios';

class StockApi {


    getArrivaleState()
    {
        var url = apiUrl + 'stocks/arrival-states';
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });
    }
    getForSaleList()
    {
        var url = apiUrl + 'stocks/forSale/';
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });

    }

    // getList() {
    //     var url = apiUrl + 'stocks';
    //     return api.call('get', url)
    //         .then(({ data }) => {
    //             return data
    //         });
    // }

    getList({
        page = 1,
        itemsPerPage = 10,
        sorter = null,
        filters = {},
        search = '',
        priceMin = '',
        priceMax = '',
        isOpen = false,
        monthFrom = '',
        yearFrom = '',
        monthTo = '',
        yearTo = '',
    }) {
        let url = apiUrl + 'stocks';

        // Build query string parameters
        const params = new URLSearchParams();

        params.append('page', page);
        params.append('itemsPerPage', itemsPerPage);

        if (sorter?.column) {
            params.append('sortColumn', sorter.column);
            params.append('sortAsc', sorter.asc);
        }

        if (search) {
            params.append('search', search);
        }

        if (priceMin) {
            params.append('priceMin', priceMin);
        }
        if (priceMax) {
            params.append('priceMax', priceMax);
        }

        if (monthFrom) {
            params.append('monthFrom', monthFrom);
        }
        if (yearFrom) {
            params.append('yearFrom', yearFrom);
        }
        if (monthTo) {
            params.append('monthTo', monthTo);
        }
        if (yearTo) {
            params.append('yearTo', yearTo);
        }

        params.append('isOpen', isOpen);

        // Append filters to the query string
        Object.keys(filters).forEach((key) => {
            if (filters[key]) {
                params.append(`filters[${key}]`, filters[key]);
            }
        });

        // Add query string to URL
        url += `?${params.toString()}`;

        console.log(url);

        return api.call('get', url).then(({ data }) => {
            return data; // Expected to return { items, totalItems }
        });
    }

    // Dedicated Sales Report list endpoint. Returns a flat row shape per
    // stock with payment-bucket sums included. Safe to bind directly to
    // the table without nested-property access.
    getSalesReportList({
        page = 1,
        itemsPerPage = 20,
        sorter = null,
        filters = {},
        search = '',
        priceMin = '',
        priceMax = '',
    } = {}) {
        let url = apiUrl + 'stocks/sales-report-list';
        const params = new URLSearchParams();
        params.append('page', page);
        params.append('itemsPerPage', itemsPerPage);
        if (sorter?.column) {
            params.append('sortColumn', sorter.column);
            params.append('sortAsc', sorter.asc);
        }
        if (search) params.append('search', search);
        if (priceMin) params.append('priceMin', priceMin);
        if (priceMax) params.append('priceMax', priceMax);
        Object.keys(filters || {}).forEach((k) => {
            if (filters[k]) params.append(`filters[${k}]`, filters[k]);
        });
        url += `?${params.toString()}`;
        return api.call('get', url).then(({ data }) => data);
    }


    // Lightweight export endpoint — returns ONLY (stockNo, latestStatus, brand, model, price)
    // for every row matching the filters. Used by the Download CSV / Download All buttons.
    export({
        filters = {},
        priceMin = '',
        priceMax = '',
        isOpen = false,
        monthFrom = '',
        yearFrom = '',
        monthTo = '',
        yearTo = '',
    } = {}) {
        let url = apiUrl + 'stocks/export';
        const params = new URLSearchParams();
        if (priceMin) params.append('priceMin', priceMin);
        if (priceMax) params.append('priceMax', priceMax);
        if (monthFrom) params.append('monthFrom', monthFrom);
        if (yearFrom) params.append('yearFrom', yearFrom);
        if (monthTo) params.append('monthTo', monthTo);
        if (yearTo) params.append('yearTo', yearTo);
        params.append('isOpen', isOpen);
        Object.keys(filters).forEach((key) => {
            if (filters[key]) {
                params.append(`filters[${key}]`, filters[key]);
            }
        });
        url += `?${params.toString()}`;
        return api.call('get', url).then(({ data }) => data);
    }

    getListByFilter(filters) {
        const params = new URLSearchParams(filters).toString();
        var url = apiUrl + 'stocks?' + params;
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });
    }

    getNextStockNumber() {
        var url = apiUrl + 'stocks/GetNextStockNumber';
        return api.call('get', url)
            .then(({ data }) => {
                return data
            });
    }

    get(id) {
        var url = apiUrl + 'stocks/';
        return api.call('get', url + id)
            .then(({ data }) => {
                return data
            });
    }

    create(data) {
        var url = apiUrl + 'stocks';
        return api.call('post', url, data)
            .then(({ data }) => {
                return data
            });

    }


    updateImagePosition(data) {
        var url = apiUrl + 'stocks/imageposition/';
        return api.call('put', url + data.id, data)
            .then(({ data }) => {
                return data
            });
    }

    updateDefaultImages(data) {
        var url = apiUrl + 'stocks/defaultimage/';
        return api.call('put', url + data.id, data)
            .then(({ data }) => {
                return data
            });
    }

    updateAdsInfo(data) {
        var url = apiUrl + 'stocks/adsinfo/';
        return api.call('put', url + data.id, data)
            .then(({ data }) => {
                return data
            });
    }

    update(data) {
        var url = apiUrl + 'stocks/';
        return api.call('put', url + data.id, data)
            .then(({ data }) => {
                return data
            });
    }
    delete(id) {
        var url = apiUrl + 'stocks/';
        return api.call('delete', url + id)
            .then(({ data }) => {
                return data
            });
    }

    deleteVehicleImage(imageId) {
        var url = apiUrl + 'stocks/image/';
        return api.call('delete', url + imageId)
            .then(({ data }) => {
                return data
            });
    }


    updateStockStatus(data) {
        var url = apiUrl + 'stocks/UpdateStockStatus/';
        return api.call('put', url + data.stockId, data)
            .then(({ data }) => {
                return data
            });
    }

    updateRemarks(data) {
        var url = apiUrl + 'stocks/UpdateRemarks/';
        return api.call('put', url + data.stockId, data)
            .then(({ data }) => {
                return data
            });
    }

    updateVehicleImages(id, data) {
        var url = apiUrl + 'stocks/UpdateVehicleImages/';
        return api.call('put', url + id, data)
            .then(({ data }) => {
                return data
            });
    }

    updatePuspakomB2SlipDocuments(id, data) {
        var url = apiUrl + 'stocks/UpdatePuspakomB2SlipDocuments/';
        return api.call('put', url + id, data)
            .then(({ data }) => {
                return data
            });
    }

    removePuspakomB2SlipDocuments(registrationId, documentId) {
        var url = apiUrl + 'stocks/RemovePuspakomB2SlipDocument/' + registrationId + '/' + documentId;
        return api.call('put', url)
            .then(({ data }) => {
                return data
            });
    }

    updatePuspakomB7SlipDocuments(id, data) {
        var url = apiUrl + 'stocks/UpdatePuspakomB7SlipDocuments/';
        return api.call('put', url + id, data)
            .then(({ data }) => {
                return data
            });
    }

    removePuspakomB7SlipDocuments(registrationId, documentId) {
        var url = apiUrl + 'stocks/RemovePuspakomB7SlipDocument/' + registrationId + '/' + documentId;
        return api.call('put', url)
            .then(({ data }) => {
                return data
            });
    }

    updateJpjDaftarDocuments(id, data) {
        var url = apiUrl + 'stocks/UpdateJpjDaftarDocuments/';
        return api.call('put', url + id, data)
            .then(({ data }) => {
                return data
            });
    }

    removeJpjDaftarDocuments(registrationId, documentId) {
        var url = apiUrl + 'stocks/RemoveJpjDaftarDocument/' + registrationId + '/' + documentId;
        return api.call('put', url)
            .then(({ data }) => {
                return data
            });
    }


    updateJpjHakMilikDocuments(id, data) {
        var url = apiUrl + 'stocks/UpdateJpjHakMilikDocuments/';
        return api.call('put', url + id, data)
            .then(({ data }) => {
                return data
            });
    }

    removeJpjHakMilikDocuments(registrationId, documentId) {
        var url = apiUrl + 'stocks/RemoveJpjHakMilikDocument/' + registrationId + '/' + documentId;
        return api.call('put', url)
            .then(({ data }) => {
                return data
            });
    }

    updateJpjGeranDocuments(id, data) {
        var url = apiUrl + 'stocks/UpdateJpjGeranDocuments/';
        return api.call('put', url + id, data)
            .then(({ data }) => {
                return data
            });
    }

    removeJpjGeranDocuments(registrationId, documentId) {
        var url = apiUrl + 'stocks/RemoveJpjGeranDocument/' + registrationId + '/' + documentId;
        return api.call('put', url)
            .then(({ data }) => {
                return data
            });
    }


    updateBolDocuments(id, data) {
        var url = apiUrl + 'stocks/UpdateBolDocuments/';
        return api.call('put', url + id, data)
            .then(({ data }) => {
                return data
            });
    }

    removeBolDocuments(importId, documentId) {
        var url = apiUrl + 'stocks/RemoveBolDocument/' + importId + '/' + documentId;
        return api.call('put', url)
            .then(({ data }) => {
                return data
            });
    }

    updateK8Documents(id, data) {
        var url = apiUrl + 'stocks/UpdateK8Documents/';
        return api.call('put', url + id, data)
            .then(({ data }) => {
                return data
            });
    }

    removeK8Documents(clearanceId, documentId) {
        var url = apiUrl + 'stocks/RemoveK8Document/' + clearanceId + '/' + documentId;
        return api.call('put', url)
            .then(({ data }) => {
                return data
            });
    }


    //
    updateK1Documents(id, data) {
        var url = apiUrl + 'stocks/UpdateK1Documents/';
        return api.call('put', url + id, data)
            .then(({ data }) => {
                return data
            });
    }

    removeK1Documents(clearanceId, documentId) {
        var url = apiUrl + 'stocks/RemoveK1Document/' + clearanceId + '/' + documentId;
        return api.call('put', url)
            .then(({ data }) => {
                return data
            });
    }
    //
    updateLouDocuments(id, data) {
        var url = apiUrl + 'stocks/UpdateLouDocuments/';
        return api.call('put', url + id, data)
            .then(({ data }) => {
                return data
            });
    }

    removeLouDocuments(loanId, documentId) {
        var url = apiUrl + 'stocks/RemoveLouDocument/' + loanId + '/' + documentId;
        return api.call('put', url)
            .then(({ data }) => {
                return data
            });
    }

    // Receipt Documents
    updateReceiptDocuments(id, data) {
        var url = apiUrl + 'stocks/UpdateReceiptDocuments/';
        return api.call('put', url + id, data)
            .then(({ data }) => {
                return data
            });
    }

    removeReceiptDocuments(saleId, documentId) {
        var url = apiUrl + 'stocks/RemoveReceiptDocument/' + saleId + '/' + documentId;
        return api.call('put', url)
            .then(({ data }) => {
                return data
            });
    }

    // Insurance Documents
    updateInsuranceDocuments(id, data) {
        var url = apiUrl + 'stocks/UpdateInsuranceDocuments/';
        return api.call('put', url + id, data)
            .then(({ data }) => {
                return data
            });
    }

    removeInsuranceDocuments(registrationId, documentId) {
        var url = apiUrl + 'stocks/RemoveInsuranceDocument/' + registrationId + '/' + documentId;
        return api.call('put', url)
            .then(({ data }) => {
                return data
            });
    }

    // RoadTax Documents
    updateRoadTaxDocuments(id, data) {
        var url = apiUrl + 'stocks/UpdateRoadTaxDocuments/';
        return api.call('put', url + id, data)
            .then(({ data }) => {
                return data
            });
    }

    removeRoadTaxDocuments(registrationId, documentId) {
        var url = apiUrl + 'stocks/RemoveRoadTaxDocument/' + registrationId + '/' + documentId;
        return api.call('put', url)
            .then(({ data }) => {
                return data
            });
    }

    // ReceiptEDaftar Documents
    updateReceiptEDaftarDocuments(id, data) {
        var url = apiUrl + 'stocks/UpdateReceiptEDaftarDocuments/';
        return api.call('put', url + id, data)
            .then(({ data }) => {
                return data
            });
    }

    removeReceiptEDaftarDocuments(registrationId, documentId) {
        var url = apiUrl + 'stocks/RemoveReceiptEDaftarDocument/' + registrationId + '/' + documentId;
        return api.call('put', url)
            .then(({ data }) => {
                return data
            });
    }

    // ReceiptKastam Documents
    updateReceiptKastamDocuments(id, data) {
        var url = apiUrl + 'stocks/UpdateReceiptKastamDocuments/';
        return api.call('put', url + id, data)
            .then(({ data }) => {
                return data
            });
    }

    removeReceiptKastamDocuments(registrationId, documentId) {
        var url = apiUrl + 'stocks/RemoveReceiptKastamDocument/' + registrationId + '/' + documentId;
        return api.call('put', url)
            .then(({ data }) => {
                return data
            });
    }

    // ExportCertificate Documents
    updateExportCertificateDocuments(id, data) {
        var url = apiUrl + 'stocks/UpdateExportCertificateDocuments/';
        return api.call('put', url + id, data)
            .then(({ data }) => {
                return data
            });
    }

    removeExportCertificateDocuments(clearanceId, documentId) {
        var url = apiUrl + 'stocks/RemoveExportCertificateDocument/' + clearanceId + '/' + documentId;
        return api.call('put', url)
            .then(({ data }) => {
                return data
            });
    }

    // CustomerIc Documents
    updateCustomerIcDocuments(id, data) {
        var url = apiUrl + 'stocks/UpdateCustomerIcDocuments/';
        return api.call('put', url + id, data)
            .then(({ data }) => {
                return data
            });
    }

    removeCustomerIcDocuments(saleId, documentId) {
        var url = apiUrl + 'stocks/RemoveCustomerIcDocument/' + saleId + '/' + documentId;
        return api.call('put', url)
            .then(({ data }) => {
                return data
            });
    }

    addAdministrativeCostItem(id, data) {
        var url = apiUrl + 'stocks/AddAdministrativeCostItem/';
        return api.call('put', url + id, data)
            .then(({ data }) => {
                return data
            });
    }

    changeStockNo(id, data) {
        var url = apiUrl + 'stocks/UpdateStockNo/';
        return api.call('put', url + id, data)
            .then(({ data }) => {
                return data
            });
    }




    updateAdministrativeCostItem(id, data) {
        var url = apiUrl + 'stocks/UpdateAdministrativeCostItem/';
        return api.call('put', url + id, data)
            .then(({ data }) => {
                return data
            });
    }

    removeAdministrativeCostItem(id) {
        var url = apiUrl + 'stocks/RemoveAdministrativeCostItem/' + id;
        return api.call('put', url)
            .then(({ data }) => {
                return data
            });
    }

    addExpenseItem(id, data) {
        var url = apiUrl + 'stocks/AddExpenseItem/';
        return api.call('put', url + id, data)
            .then(({ data }) => {
                return data
            });
    }


    removeExpenseItem(id) {
        var url = apiUrl + 'stocks/RemoveExpenseItem/' + id;
        return api.call('put', url)
            .then(({ data }) => {
                return data
            });
    }
    updateExpenseItem(id, data) {
        var url = apiUrl + 'stocks/UpdateExpenseItem/';
        return api.call('put', url + id, data)
            .then(({ data }) => {
                return data
            });
    }

    // ExpensePayment — partial payments against a fixed expense category
    // (ExpenseType = "SvcEzCare" | "Interior" | "Paint" | "Tyre" | "Rental")
    // OR a specific ExpenseItem (free-form). The payload carries exactly one
    // of `expenseType` or `expenseItemId`.
    addExpensePayment(stockId, data) {
        var url = apiUrl + 'stocks/AddExpensePayment/';
        return api.call('put', url + stockId, data)
            .then(({ data }) => {
                return data
            });
    }

    updateExpensePayment(paymentId, data) {
        var url = apiUrl + 'stocks/UpdateExpensePayment/';
        return api.call('put', url + paymentId, data)
            .then(({ data }) => {
                return data
            });
    }

    removeExpensePayment(paymentId) {
        var url = apiUrl + 'stocks/RemoveExpensePayment/' + paymentId;
        return api.call('put', url)
            .then(({ data }) => {
                return data
            });
    }

    // AdminitrativeCostPayment — partial payments against a fixed admin
    // cost category (CostType = "DutyTax" | "Ap" | "Forwarding" | "IntFs"
    // | "Puspakom" | "TransferFee" | "Others"). Routes use the CORRECT
    // spelling 'Administrative' to match the existing AdministrativeCostItem
    // precedent.
    addAdminitrativeCostPayment(stockId, data) {
        var url = apiUrl + 'stocks/AddAdministrativeCostPayment/';
        return api.call('put', url + stockId, data)
            .then(({ data }) => {
                return data
            });
    }

    updateAdminitrativeCostPayment(paymentId, data) {
        var url = apiUrl + 'stocks/UpdateAdministrativeCostPayment/';
        return api.call('put', url + paymentId, data)
            .then(({ data }) => {
                return data
            });
    }

    removeAdminitrativeCostPayment(paymentId) {
        var url = apiUrl + 'stocks/RemoveAdministrativeCostPayment/' + paymentId;
        return api.call('put', url)
            .then(({ data }) => {
                return data
            });
    }

    // PurchasePayment — partial installments against the Stock's Purchase
    // row. Multi-currency is allowed per Stock; each payload carries
    // supplierCurrency, foreignAmount, exchangeRate, localAmount.
    addPurchasePayment(stockId, data) {
        var url = apiUrl + 'stocks/AddPurchasePayment/';
        return api.call('put', url + stockId, data)
            .then(({ data }) => {
                return data
            });
    }

    updatePurchasePayment(paymentId, data) {
        var url = apiUrl + 'stocks/UpdatePurchasePayment/';
        return api.call('put', url + paymentId, data)
            .then(({ data }) => {
                return data
            });
    }

    removePurchasePayment(paymentId) {
        var url = apiUrl + 'stocks/RemovePurchasePayment/' + paymentId;
        return api.call('put', url)
            .then(({ data }) => {
                return data
            });
    }

    // SalePayment — customer payments against the Stock's Sale row. Single
    // MYR currency. Each payload carries amount, paymentDate, referenceNo,
    // paymentMethod, remarks, documentId (receipt scan).
    addSalePayment(stockId, data) {
        var url = apiUrl + 'stocks/AddSalePayment/';
        return api.call('put', url + stockId, data)
            .then(({ data }) => {
                return data
            });
    }

    updateSalePayment(paymentId, data) {
        var url = apiUrl + 'stocks/UpdateSalePayment/';
        return api.call('put', url + paymentId, data)
            .then(({ data }) => {
                return data
            });
    }

    removeSalePayment(paymentId) {
        var url = apiUrl + 'stocks/RemoveSalePayment/' + paymentId;
        return api.call('put', url)
            .then(({ data }) => {
                return data
            });
    }

    addArrivalItem(id, data) {
        var url = apiUrl + 'stocks/AddArrivalCheckLisItem/';
        return api.call('put', url + id, data)
            .then(({ data }) => {
                return data
            });
    }


    removeArrivalItem(id) {
        var url = apiUrl + 'stocks/RemoveArrivalCheckLisItem/' + id;
        return api.call('put', url)
            .then(({ data }) => {
                return data
            });
    }
    updateArrivalItem(id, data) {
        var url = apiUrl + 'stocks/UpdateArrivalItem/';
        return api.call('put', url + id, data)
            .then(({ data }) => {
                return data
            });
    }

    // Bulk Import Methods
    bulkUpload(file) {
        const formData = new FormData();
        formData.append('file', file);

        var url = apiUrl + 'stocks/bulk-upload';
        return api.call('post', url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(({ data }) => {
                return data.result || data;
            });
    }

    confirmImport(confirmDto) {
        var url = apiUrl + 'Stocks/bulk-import/confirm';
        return api.call('post', url, confirmDto)
            .then(({ data }) => {
                return data.result || data;
            });
    }

    downloadTemplate() {
        var url = apiUrl + 'stocks/bulk-import/template';

        // Use axios directly for blob downloads since api.call doesn't support responseType config
        const token = window.localStorage.getItem('token');

        return axios.get(url, {
            responseType: 'blob',
            headers: {
                'Authorization': 'Bearer ' + token,
                'api-token': token
            }
        })
            .then((response) => {
                // Create download link
                const blob = new Blob([response.data], { type: 'text/csv' });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = 'stock_import_template_' + new Date().toISOString().slice(0, 10) + '.csv';
                link.click();
                window.URL.revokeObjectURL(link.href);
            });
    }
}

export default StockApi;
